import { Badge } from '@amzn/awsui-components-core';
import { WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import React, { FunctionComponent } from 'react';

interface Props {
  state: WorkflowState;
}

export const PublicationStateBadge: FunctionComponent<Props> = ({ state }) => {
  const displayConfig = new Map<
    WorkflowState,
    { color: 'blue' | 'grey' | 'green' | 'red'; displayName: string }
  >([
    [WorkflowState.PUBLISHED, { color: 'grey', displayName: 'AWS' }],
    [WorkflowState.FINALIZING, { color: 'grey', displayName: 'AWS' }],
    [WorkflowState.FINALIZED, { color: 'grey', displayName: 'AWS' }],
    [WorkflowState.REVOKED, { color: 'grey', displayName: 'AWS' }],
    [WorkflowState.DISTRIBUTED, { color: 'green', displayName: 'Public' }],
  ]);

  const config = displayConfig.get(state) || { color: 'grey', displayName: 'Unknown' };
  return <Badge color={config.color} children={config.displayName} />;
};
